module.exports = __webpack_public_path__ + "static/media/image6.3e34ab0b.png";